import {
  type RouteObject,
} from "react-router";
import ShowCopyPage from "show/copy/app";
import { ShowEditApp } from "show/edit";
import { ShowFromWebfromApp } from "show/FromWebform/App";
import { ShowListApp } from "show/list";
import { LockShowsApp } from "show/lock/App";
import { ShowNewApp } from "show/new";
import { AppNewInvoiceFromShow } from "invoice/newinvoicefromshow/App";

declare let viewModel: any;

export const showRoute: RouteObject = {
  path: "show",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ShowListApp,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ShowNewApp,
  }, {
    path: ":key/edit",
    loader: () => viewModel,
    Component: ShowEditApp,
  }, {
    path: ":key/copy",
    loader: () => viewModel,
    Component: ShowCopyPage,
  }, {
    path: ":key/fromwebform",
    loader: () => viewModel,
    Component: ShowFromWebfromApp,
  }, {
    path: ":key/invoice",
    loader: () => viewModel,
    Component: AppNewInvoiceFromShow,
  }, {
    path: "lock",
    loader: () => viewModel,
    Component: LockShowsApp
  }]
};